export default __webpack_public_path__ + "static/media/409.bc52c32d.gif";